import React from "react";
import MemberAvatar from "@/components/common/MemberAvatar";
import ProgramBadge from "@/components/sponsors/ProgramBadge";
import { Button } from "@/components/ui/button";

/**
 * "My Sponsor Connections" panel plus the outgoing-request summary.
 *
 * Extracted verbatim from src/pages/Dashboard.jsx during the code-quality pass:
 * markup, copy, data-testids and behaviour are unchanged.
 */
export default function ConnectionsSection({ connections, outgoing, navigate }) {
  return (
    <section id="connections" className="sm-card p-6 bg-white">
      <h2 className="font-display text-xl font-bold text-[#1F2A2E]">My Sponsor Connections</h2>
      {connections.length === 0 ? (
        <p className="mt-3 text-sm text-[#4B5A60]">
          No active sponsorship connections yet. When a sponsor accepts your request, they appear
          here.
        </p>
      ) : (
        <ul className="mt-4 divide-y divide-[#E3DED4]">
          {connections.map((c) => (
            <li key={c.id} data-testid={`connection-${c.id}`} className="py-3 flex items-center gap-3">
              <MemberAvatar user={c.other_user} size={44} />
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-sm text-[#1F2A2E]">{c.other_user?.display_name}</p>
                <div className="flex items-center gap-2 text-xs text-[#4B5A60]">
                  {c.sponsor_program ? <ProgramBadge program={c.sponsor_program} /> : null}
                  <span>{c.role === "sponsee" ? "Your sponsor" : "Your sponsee"}</span>
                </div>
              </div>
              <Button
                size="sm"
                onClick={() => navigate(`/messages?c=${c.conversation_id}`)}
                data-testid={`connection-message-${c.id}`}
                className="bg-[#1F6F78] hover:bg-[#185B62] text-white"
              >
                Message
              </Button>
            </li>
          ))}
        </ul>
      )}

      {outgoing.length > 0 && (
        <div className="mt-5 pt-4 border-t border-[#E3DED4]">
          <h3 className="text-sm font-bold text-[#1F2A2E]">Requests you sent</h3>
          <ul className="mt-2 space-y-2">
            {outgoing.map((r) => (
              <li
                key={r.id}
                data-testid={`outgoing-request-${r.id}`}
                className="flex items-center justify-between gap-3 text-sm"
              >
                <span className="text-[#1F2A2E]">{r.other_user?.display_name}</span>
                <span
                  className={`px-2 py-0.5 rounded-full text-xs font-semibold ${
                    r.status === "pending"
                      ? "bg-[#FBF0DC] text-[#8A5A12]"
                      : "bg-[#FBE6E4] text-[#B42318]"
                  }`}
                >
                  {r.status === "pending" ? "Waiting for reply" : "Declined"}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
}
